import { useMemo } from 'react'
import { useFeatureState } from '../../store/featureState'


export const useHasFeature = (shortName: string|undefined) => {
  const features = useFeatureState((state) => state.features)

  

  return useMemo(() => {
    if(!shortName)
      return null
    return features.includes(`aptori:${shortName}`)
  }, [features, shortName])
}
